export default __webpack_public_path__ + "static/media/Hair_1_M_C3.fb45b6b3.svg";